import { IOPSReporting, IProspect } from '@common/interfaces/prospects'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { IAction } from '../apiMiddleware'
import * as actions from './actions'

export default combineReducers({
  savingArray: loadingArrayReducer([
    `${actions.prefix}/SAVE_CONTACT`,
    `${actions.prefix}/SAVE_COMPANY_INFO`,
    `${actions.prefix}/SAVE_PEOPLE_AND_TOOLS`,
    `${actions.prefix}/SUBMIT`,
  ]),
  opsReporting(state: IOPSReporting = null, action: IAction): IOPSReporting {
    switch (action.type) {
      case actions.START_SUCCESS:
      case actions.SAVE_CONTACT_SUCCESS:
      case actions.SAVE_COMPANY_INFO_SUCCESS:
      case actions.SAVE_PEOPLE_AND_TOOLS_SUCCESS:
      case actions.GET_CODAT_LINK_SUCCESS:
      case actions.UPLOAD_DOCUMENT_SUCCESS:
      case actions.DELETE_DOCUMENT_SUCCESS:
      case actions.SUBMIT_SUCCESS:
      case actions.SAVE_NOT_APPLICABLE_DOCUMENT_SUCCESS: {
        const data = action.data as IOPSReporting
        if (!data) {
          return state
        }

        if (!state) {
          return data || null
        }

        return {
          ...state,
          ...data,
          clientInfo: {
            ...(state.clientInfo || {}),
            ...(data?.clientInfo || {}),
          } as IProspect,
        }
      }
      default:
        return state
    }
  },
})
